import * as React from 'react';
import classNames from 'classnames';

type ListItemBuilder = (() => React.ReactNode) | (() => string);

interface ListItem {
	key: string | number;
	buildItem: ListItemBuilder;
	onItemSelected?: () => void;
	children?: ListItem[];
}

interface ChevronListGroupItemProps {
	collapsableId: string;
	buildItem: ListItemBuilder;
}

class ChevronListGroupItem extends React.Component<ChevronListGroupItemProps, { collapsed: boolean }> {

	constructor(props: { collapsableId: string, buildItem: ListItemBuilder }) {
		super(props);

		this.state = { collapsed: true };
	}

	render() {

		const onClick = () => this.setState({ collapsed: !this.state.collapsed });

		const chevronClass = this.state.collapsed ? 'glyphicon glyphicon-chevron-right' : 'glyphicon glyphicon-chevron-down';
		return <a data-target={`#${this.props.collapsableId}`} className='list-group-item needsclick' data-toggle='collapse' onClick={onClick}>
			<i className={chevronClass}></i> {this.props.buildItem()}
		</a>;
	}
}

interface ListGroupItemProps {
	buildItem: ListItemBuilder;
	onItemSelected?: () => void;
	selected: boolean;
}

class ListGroupItem extends React.Component<ListGroupItemProps, EmptyState> {
	render() {

		const onClick = () => {
			this.props.onItemSelected?.();
		};

		return <a className={classNames({ 'list-group-item needsclick': true, 'selected': this.props.selected })} onClick={onClick}>
			{this.props.buildItem()}
		</a>;
	}
}

interface ListGroupProps {
	items: ListItem[];
	collapsableId: string;
	selectedItem: Nullable<ListItem>;
	onSelectionChanged: (item: ListItem) => void;
	selectable?: boolean;
}

const ListGroup = (props: ListGroupProps) => {
	const items = props.items.map(x => buildListItem(x, props.selectedItem, props.onSelectionChanged, props.selectable));
	return <div id={props.collapsableId} className='list-group needsclick collapse' >
		{items}
	</div>;
};

const buildListItem = (item: ListItem, selectedItem: Nullable<ListItem>, onSelectionChanged: (item: ListItem) => void, selectable?: boolean): React.ReactNode => {

	if (!item.children || item.children.length === 0) {

		const onItemSelected = () => {
			item.onItemSelected?.();
			onSelectionChanged(item);
		};
		const selected = !!(selectable && selectedItem && item.key === selectedItem.key);
		return <ListGroupItem key={item.key} buildItem={item.buildItem} onItemSelected={onItemSelected} selected={selected} />;
	}


	const collapsableId = ('' + item.key).replace(/\./g, '-').replace(/\[|\]/g, '_').replace(/\s/g, '');
	return (
		<React.Fragment key={item.key}>
			<ChevronListGroupItem collapsableId={collapsableId} buildItem={item.buildItem} />
			<ListGroup collapsableId={collapsableId} items={item.children} selectedItem={selectedItem} selectable={selectable} onSelectionChanged={onSelectionChanged} />
		</React.Fragment>);
};

interface Props {
	items: ListItem[];
	height?: number;
	selectable?: boolean;
}

interface State {
	items: ListItem[];
	selectedItem: Nullable<ListItem>;
}

export default class NestedList extends React.Component<Props, State> {

	constructor(props: { items: ListItem[] }) {
		super(props);
		this.state = {
			items: [...props.items],
			selectedItem: null
		};
	}

	render() {

		const onItemSelected = (item: ListItem) => {
			this.setState({ selectedItem: item });
		};

		const style = {
			height: this.props.height || 400,
			minHeight: this.props.height || 400
		};

		return <div className='nested-list' style={style}>
			<div className='list-group list-group-root'>
				{this.state.items.map(item => buildListItem(item, this.state.selectedItem, onItemSelected, this.props.selectable))}
			</div>
		</div>;
	}
}
